import withBlockTemplatesDependencies from './with-block-templates-dependencies';

export default {
  withBlockTemplatesDependencies,
};
